module.exports = __webpack_public_path__ + "img/bulletin.508574c7.png";